import axios from "axios";

export const getCollaboratorsCalendar = (
  id,
  collaborators,
  year,
  squads,
  zones,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `/team/collaborators_calendar`;
  let params = {
    organizationId: id,
    collaborators: collaborators.map(({ value }) => value),
    squads: squads.map(({ value }) => value),
    zones: zones.map(({ value }) => value),
    year: year,
    clientCRMTypes: clientCRMTypes,
    clientCRMGroup: clientCRMGroup,
    deletedStatus: deletedStatus
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorsSynthesis = (
  id,
  year,
  squads,
  zones,
  clientCRMTypes,
  clientCRMGroup,
  deletedStatus
) => {
  const requestUrl = `/team/collaborators_synthesis`;
  let params = {
    organizationId: id,
    squads: squads.map(({ value }) => value),
    zones: zones.map(({ value }) => value),
    year: year,
    clientCRMTypes: clientCRMTypes,
    clientCRMGroup: clientCRMGroup,
    deletedStatus: deletedStatus
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/collaborator-calendar.js